// Görev 13, fix round 1 (review) — HA akıllı istatistik satırının mount kararı.
//
// KÖK NEDEN: `canRead('HA')` TEK BAŞINA yanlıştı. AuthContext.js'teki hasPermission,
// enterpriseAdmin için `if (isEnterpriseAdmin) return true;` ile KOŞULSUZ true döner — tenant'ın
// HA aboneliği olup olmadığına hiç bakmadan. Yani bir enterpriseAdmin, HA modülü OLMAYAN bir
// tenant'ta bile canRead('HA') === true görüyordu; satır mount oluyor, GET /v1/ha/metrics
// gidiyor, backend 403 vermiyor (ModulePermissionHandler enterpriseAdmin'i zaten geçiriyor) ve
// HaMetricsDataAccess → HaCatalogDataAccess → HaSettingsDataAccess.GetOrCreateAsync tenant için
// sessizce bir HaSettings satırı YAZIYORDU — dört metrik de locked_module döndüğü için DOM boş
// kalıyor, yani görsel semptom YOK ama gerçek bir ağ isteği + gerçek bir DB yazımı her dashboard
// yüklemesinde oluyordu.
//
// DÜZELTME: `hasModule('HA') && canRead('HA')`. hasModule (AuthContext.js) tenant ABONELİĞİNİ
// kullanıcının kendi ayrıcalığından BAĞIMSIZ olarak sorar ("Module AVAILABILITY... independent of
// the user's own privileges" — kendi yorumu) — SidebarMenu.js zaten HR Analytics menü öğesini
// AYNI ilkelle (moduleGated → hasModule(moduleCode)) kapatıyor, burada YENİ bir ilkel İCAT
// EDİLMEDİ. İKİSİ BİRDEN gerekli: yalnız hasModule, HA aboneliği olan bir tenant'ta ayrıcalıksız
// sıradan bir çalışana da satırı gösterirdi; yalnız canRead bugünkü hatanın ta kendisidir.
//
// SAF FONKSİYON olarak (DashboardPage.js'in İÇİNDE değil, ayrı bir dosyada) çıkarılmasının
// nedeni: DashboardPage.js 20'den fazla kart import ediyor, birkaçı services/*.js üzerinden
// axios'a kadar iniyor — DashboardPage'i (ya da ondan herhangi bir named export'u) bir test
// dosyasından import etmek bu depodaki bilinen CRA5 + axios ESM transformIgnorePatterns açığına
// toslar. Bu dosya HİÇBİR ŞEY import etmiyor, dolayısıyla o riski hiç taşımıyor ve AuthContext'i
// (ya da React'ı) hiç render etmeden düz fonksiyon çağrılarıyla test edilebiliyor.
export function resolveHasHaModule({ hasModule, canRead }) {
  return hasModule('HA') && canRead('HA');
}
